import 'readmore-js';

$(function() {
    $('.readmore').readmore({
        embedCSS: true,
        moreLink: '<a href="#" class="mt-4 btn btn-outline-primary">LEES MEER</a>',
        lessLink: '<a href="#" class="mt-4 btn btn-outline-primary">LEES MINDER</a>',
        collapsedHeight: 250,
    });
});
